let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8xY1p")).then(() => parcelRequire('5c4St'));